import Phaser from 'phaser';
import { GAME_HEIGHT } from '../config/constants';

export class EnemyProjectile extends Phaser.Physics.Arcade.Sprite {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    speed: number,
    group: Phaser.Physics.Arcade.Group
  ) {
    super(scene, x, y, texture);

    // Add to scene and group
    scene.add.existing(this);
    group.add(this);

    // Enable physics
    scene.physics.add.existing(this);

    // Set velocity downward
    this.setVelocityY(speed);

    // Set hitbox
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(10, 14);
  }

  update(): void {
    // Destroy if off screen
    if (this.y > GAME_HEIGHT + 20) {
      this.destroy();
    }
  }
}






